import { ReactNode, useState } from "react"
import cn from "classnames"

import style from "./style.module.scss"

import { Tooltip } from "components/Tooltip"
import { Icon } from "components/Icon"

interface HelpTooltipProps {
    overlay?: ReactNode
    className?: string
    tooltipClassName?: string
    iconWrapperClassName?: string
    placement?: string
    iconStyles?: Record<string, string | number>
}

export function HelpTooltip({
    overlay,
    className,
    iconWrapperClassName,
    tooltipClassName,
    placement,
    iconStyles,
}: HelpTooltipProps) {
    const [tooltipOpened, setTooltipOpened] = useState(false)
    return (
        <Tooltip
            placement={placement ?? "top"}
            onVisibleChange={setTooltipOpened}
            overlay={overlay}
            className={className}
            tooltipClassName={tooltipClassName}
        >
            <div
                className={cn(style.wrapper, iconWrapperClassName)}
                data-testid="help-tooltip-icon"
            >
                <Icon
                    size={24}
                    type={tooltipOpened ? "help-circle-shaded" : "help-circle"}
                    {...(iconStyles ?? {})}
                />
            </div>
        </Tooltip>
    )
}
